import NzRollReturnsAdapter from './base';

export default class ReturnDate extends NzRollReturnsAdapter {
  modelNamePlural = 'returnDates';
}
